function bindQoaleSmoothAnchors(section) {
  section.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const y = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
}

/* Teller op basis van Dawn's slideChanged-event (currentPage telt alleen zichtbare
   slides). De eerdere aria-current-benadering racete met Dawn's eigen update en
   viel dan terug op "1 / N" terwijl je op een andere foto stond. */
function bindQoaleMediaCounter(section) {
  const counter = section.querySelector('.qoale-pdp__media-counter');
  if (!counter) return;

  const visibleCount = () =>
    section.querySelectorAll('.product__media-item:not(.qoale-media-hidden)').length;

  let page = 1;
  const render = () => {
    const total = visibleCount();
    if (total) counter.textContent = `${Math.min(page, total)} / ${total}`;
  };

  render();
  section._qoaleCounterUpdate = () => { page = 1; render(); };
  section.querySelector('media-gallery slider-component')?.addEventListener('slideChanged', (event) => {
    if (event.detail?.currentPage) page = event.detail.currentPage;
    render();
  });
}

/* Gallery-filter per variant: owner markeerde media-alts met de variantnaam
   (bv. "Desert Dreamer"). Media met een ándere variantnaam in de alt worden
   verborgen; media zonder variantnaam (generiek/lifestyle) blijven staan. */
function qoaleFilterMediaByVariant(section, variantTitle) {
  let titles = [];
  try { titles = JSON.parse(section.dataset.qoaleVariants || '[]'); } catch (e) { return; }
  if (!variantTitle || !titles.length) return;

  const others = titles.filter((t) => t !== variantTitle);
  section.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach((item) => {
    const alt = item.querySelector('img')?.alt || '';
    const isOther = others.some((t) => alt.includes(t));
    const isCurrent = alt.includes(variantTitle);
    item.classList.toggle('qoale-media-hidden', isOther && !isCurrent);
  });

  // Als de actieve thumb/slide verborgen raakte: spring naar de eerste zichtbare.
  const active = section.querySelector('.thumbnail[aria-current]');
  if (active && active.closest('.qoale-media-hidden')) {
    section.querySelector('.thumbnail-list__item:not(.qoale-media-hidden) .thumbnail')?.click();
  }
  section._qoaleCounterUpdate?.();
}

/* Variant-afhankelijke microtekst die Dawn niet zelf ververst (kleurnaam, mood,
   BNPL-regel, sticky bar) syncen uit de door Dawn gefetchte sectie-HTML. */
function bindQoaleVariantSync(section) {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event?.data || {};
    if (data.sectionId && data.sectionId !== section.dataset.section) return;
    if (data.html) {
      ['.qoale-pdp__variant-label', '.qoale-pdp__variant-mood', '.qoale-pdp__microcopy', '.qoale-pdp__sticky-price']
        .forEach((sel) => {
          const src = data.html.querySelector(sel);
          const dst = section.querySelector(sel);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
    }
    if (data.variant?.title) qoaleFilterMediaByVariant(section, data.variant.title);
  });
}

/* Sticky bar onderdrukken zolang de echte Add to cart zichtbaar is (geen dubbele CTA);
   daarbuiten is hij altijd zichtbaar (prototype-gedrag). */
function bindQoaleStickySuppress(section) {
  const sticky = section.querySelector('.qoale-pdp__sticky-atc');
  const submit = section.querySelector('.product-form__submit');
  if (!sticky || !submit || typeof IntersectionObserver === 'undefined') return;
  new IntersectionObserver(
    ([entry]) => sticky.classList.toggle('is-suppressed', entry.isIntersecting),
    { threshold: 0.1 }
  ).observe(submit);
}

/* Desktop-only prev/next-pijltjes op de hoofdfoto. Dawn's eigen main-slider-knoppen
   zijn een mobiel-affordance en sturen de grote foto op desktop niet betrouwbaar aan;
   daarom klikken we hier de vorige/volgende ZICHTBARE thumbnail (respecteert variant-
   filtering) en laten Dawn's setActiveMedia het werk doen. Labels lenen we uit Dawn's
   (verborgen) slider-knoppen zodat ze mee-vertaald zijn. Zichtbaarheid: CSS (hover). */
function bindQoaleGalleryArrows(section) {
  const media = section.querySelector('.qoale-pdp__media');
  const gallery = section.querySelector('media-gallery');
  if (!media || !gallery || media.querySelector('.qoale-pdp__media-nav')) return;

  const labelPrev = gallery.querySelector('.slider-button--prev')?.getAttribute('aria-label') || 'Previous';
  const labelNext = gallery.querySelector('.slider-button--next')?.getAttribute('aria-label') || 'Next';

  const visibleThumbs = () =>
    [...gallery.querySelectorAll('.thumbnail-list__item')].filter(
      (li) => !li.classList.contains('qoale-media-hidden') && li.offsetParent !== null
    );

  const go = (dir) => {
    const thumbs = visibleThumbs();
    if (thumbs.length < 2) return;
    const cur = thumbs.findIndex((li) => li.querySelector('.thumbnail[aria-current="true"]'));
    let next = (cur < 0 ? 0 : cur) + dir;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    thumbs[next].querySelector('.thumbnail')?.click();
  };

  const caret = (rot) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="transform:rotate(${rot}deg)"><path d="M15 6l-6 6 6 6"/></svg>`;

  const mk = (dir, label, rot) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'qoale-pdp__media-nav qoale-pdp__media-nav--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', label);
    b.innerHTML = caret(rot);
    b.addEventListener('click', (e) => {
      e.preventDefault();
      go(dir);
    });
    return b;
  };

  media.append(mk(-1, labelPrev, 0), mk(1, labelNext, 180));
}

/* Desktop-thumbnailrail: (1) scrollt automatisch mee naar de actieve thumbnail zodra
   die door de pijltjes/variantwissel buiten beeld valt, en (2) toont de fade onderaan
   alléén als er nog thumbnails onder de rand zitten (laatste foto dus scherp). */
function bindQoaleThumbRail(section) {
  const gallery = section.querySelector('media-gallery');
  const rail = gallery?.querySelector('.thumbnail-slider .thumbnail-list');
  if (!rail) return;
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const updateFade = () => {
    const more = rail.scrollHeight - rail.clientHeight - rail.scrollTop > 4;
    rail.classList.toggle('qoale-fade-bottom', more && isDesktop());
  };

  const scrollActiveIntoView = () => {
    if (!isDesktop()) return;
    const li = rail.querySelector('.thumbnail[aria-current="true"]')?.closest('.thumbnail-list__item');
    if (!li) return;
    const r = rail.getBoundingClientRect();
    const l = li.getBoundingClientRect();
    if (l.top < r.top) rail.scrollTop -= r.top - l.top + 8;
    else if (l.bottom > r.bottom) rail.scrollTop += l.bottom - r.bottom + 8;
  };

  // aria-current wisselt bij thumbnail-klik, pijltjes én variantwissel → volg mee.
  new MutationObserver(() => {
    scrollActiveIntoView();
    updateFade();
  }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });

  rail.addEventListener('scroll', updateFade, { passive: true });
  window.addEventListener('resize', () => {
    updateFade();
    scrollActiveIntoView();
  });
  updateFade();
  scrollActiveIntoView();
}

function initQoalePdp(root = document) {
  root.querySelectorAll('product-info.qoale-pdp').forEach((section) => {
    if (section.dataset.qoaleReady === 'true') return;
    section.dataset.qoaleReady = 'true';
    bindQoaleSmoothAnchors(section);
    bindQoaleMediaCounter(section);
    bindQoaleVariantSync(section);
    bindQoaleStickySuppress(section);
    bindQoaleGalleryArrows(section);
    bindQoaleThumbRail(section);
    qoaleFilterMediaByVariant(section, section.dataset.qoaleSelected);
  });
}

/* LOVED: de voorvertoning toont drie kaarten. De knop verplaatst dezelfde kaartengrid
   naar een toegankelijke overlay zodat alle echte reviews in een rustige, afsluitbare laag staan.
   We dupliceren geen kaarten: vertaal- en "lees meer"-interacties blijven dus intact. */
function initQoaleLovedModal(root = document) {
  root.querySelectorAll('[data-qoale-loved-more]').forEach((btn) => {
    if (btn.dataset.qoaleReady === 'true') return;
    btn.dataset.qoaleReady = 'true';

    const section = btn.closest('.qoale-loved');
    const grid = section?.querySelector('[data-qoale-loved-grid]');
    const rail = section?.querySelector('.qoale-loved__rail');
    const dialog = section?.querySelector('[data-qoale-loved-dialog]');
    const mount = dialog?.querySelector('[data-qoale-loved-dialog-grid]');
    const close = dialog?.querySelector('[data-qoale-loved-close]');
    if (!grid || !rail || !dialog || !mount) return;

    const restore = () => {
      grid.classList.remove('qoale-loved__grid--dialog');
      rail.append(grid);
      document.documentElement.classList.remove('qoale-modal-open');
    };

    const closeDialog = () => {
      if (dialog.hidden) return;
      dialog.hidden = true;
      restore();
      btn.focus();
    };

    btn.addEventListener('click', () => {
      grid.classList.add('qoale-loved__grid--dialog');
      mount.append(grid);
      document.documentElement.classList.add('qoale-modal-open');
      dialog.hidden = false;
      close?.focus();
    });

    close?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (dialog.hidden) return;
        event.preventDefault();
        closeDialog();
      }
    });
  });
}

/* Lange reviews inkorten: quotes > ~220 tekens krijgen 4 regels (CSS line-clamp)
   + een "Read more"/"Show less"-toggle per kaart. Lengte-drempel i.p.v. hoogte
   meten: verborgen kaarten (paginering) hebben geen layout om te meten. */
function initQoaleQuoteClamp(root = document) {
  root.querySelectorAll('[data-qoale-loved-grid] .qoale-loved__card').forEach((card) => {
    const quote = card.querySelector('.qoale-loved__quote');
    if (!quote || quote.dataset.qoaleClamp === 'true') return;
    quote.dataset.qoaleClamp = 'true';
    if ((quote.textContent || '').trim().length <= 220) return;

    const grid = card.closest('[data-qoale-loved-grid]');
    const moreLabel = grid?.dataset.qoaleReadMore || 'Read more';
    const lessLabel = grid?.dataset.qoaleReadLess || 'Show less';

    quote.classList.add('is-clamped');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'qoale-loved__read-more';
    toggle.textContent = moreLabel;
    toggle.addEventListener('click', () => {
      const clamped = quote.classList.toggle('is-clamped');
      toggle.textContent = clamped ? moreLabel : lessLabel;
    });
    quote.after(toggle);
  });
}

/* Reviews-vertaling: de server rendert de quote al in de actieve storefront-taal
   (zie qoale-reviews-list.liquid → {% case qloc %}). Staat er een data-qoale-original
   die afwijkt van de getoonde tekst, dan is 'ie vertaald → toon "Vertaald" + een
   "Toon origineel"-knop die tussen vertaling en origineel wisselt. */
function initQoaleReviewTranslations(root = document) {
  root.querySelectorAll('.qoale-loved__quote[data-qoale-original]').forEach((quote) => {
    if (quote.dataset.qoaleTrReady === 'true') return;
    quote.dataset.qoaleTrReady = 'true';

    const original = quote.dataset.qoaleOriginal || '';
    const translated = quote.textContent;
    // Gelijk = de actieve taal is de brontaal (of vertaling ontbrak) → niets te tonen.
    if (!original || original.trim() === translated.trim()) return;

    const grid = quote.closest('[data-qoale-loved-grid]');
    const showOriginal = grid?.dataset.qoaleShowOriginal || 'Show original';
    const showTranslation = grid?.dataset.qoaleShowTranslation || 'Show translation';
    const noteLabel = grid?.dataset.qoaleTranslatedNote || 'Translated';

    const bar = document.createElement('div');
    bar.className = 'qoale-loved__tr';
    const note = document.createElement('span');
    note.className = 'qoale-loved__tr-note';
    note.textContent = noteLabel;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qoale-loved__tr-toggle';
    btn.textContent = showOriginal;

    let onOriginal = false;
    btn.addEventListener('click', () => {
      onOriginal = !onOriginal;
      quote.textContent = onOriginal ? original : translated;
      btn.textContent = onOriginal ? showTranslation : showOriginal;
      note.hidden = onOriginal;
    });

    bar.append(note, btn);
    quote.after(bar);
  });
}

initQoalePdp();
initQoaleLovedModal();
initQoaleQuoteClamp();
initQoaleReviewTranslations();
document.addEventListener('shopify:section:load', (event) => {
  initQoalePdp(event.target);
  initQoaleLovedModal(event.target);
  initQoaleQuoteClamp(event.target);
  initQoaleReviewTranslations(event.target);
});
